import PhoneInput from "react-phone-number-input/react-hook-form-input";
import { forwardRef } from "react";

const InputPhone = forwardRef(
  ({ label, error, helperLink, helperText, ...rest }, ref) => (
    <div className={error ? "field error" : "field"}>
      <label htmlFor={rest.id}>
        {label} {error && <span className="required-mark">*</span>}
      </label>
      <PhoneInput defaultCountry="RU" ref={ref} {...rest} />
      {helperText && !error && (
        <span className="helper-text">{helperText}</span>
      )}
      {error && <span className="error-msg">{error}</span>}
      {helperLink}
    </div>
  )
);

export default InputPhone;
